export const Individual = 'Individual';
export const Registered = 'Registered';
export const NotRegistered = 'NotRegistered';
